import { render, staticRenderFns } from "./SumupResultRankTab.vue?vue&type=template&id=fc3c0522&"
import script from "./SumupResultRankTab.vue?vue&type=script&lang=ts&"
export * from "./SumupResultRankTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports